import { render, staticRenderFns } from "./ModalPendenciasUsuario.vue?vue&type=template&id=0b0283bd"
import script from "./ModalPendenciasUsuario.vue?vue&type=script&lang=js"
export * from "./ModalPendenciasUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports